import React, { useState } from "react";
import styles from "./InfoSection.module.scss";
import Location from "../../public/assets/icons/location.svg";

const InfoSection = ({ title, infos, children }) => {

  /*let tmp = infos[0];
  infos[0] = infos[1];
  infos[1] = tmp;*/

  return (
    <div className={styles.InfoSection}>
      <div className={styles.title}>{title}</div>
      {children ? (
        children
      ) : (
        <div>
          {infos &&
            infos.map((d, i) => (
              <div className={styles.infoSection} key={"info-section-" + i}>
                <div>
                  <div className={styles.infoSectionTitle}>{d.title}</div>
                  {d.openingTime && (
                    <div className={styles.infoSectionTime}>{d.openingTime}</div>
                  )}
                  {d.subtitle && d.subtitle !== d.title && (
                    <div className={styles.infoSectionSub} dangerouslySetInnerHTML={{__html: d.subtitle}}></div>
                  )}
                </div>
                <div className={styles.linksContainer}>
                  {d.links &&
                    d.links.map((l) => (
                      <a
                        key={l?.title}
                        href={l?.url}
                        target={l?.target}
                      >
                        
                        {l?.title}
                      </a>
                    ))}
                </div>
                {d.openingTime && (
                  <div className={styles.infoSectionTime}>{d.openingTime}</div>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default InfoSection;
